import React from 'react';
import style from "./index.module.css";
import {Breadcrumb, Divider} from "antd";
import CertificateNavModule from "../../components/certificateNavModule";
import {useLocation, useNavigate} from "react-router-dom";
import CompanyDescription from "../../components/companyDescription";
import CompanyStructure from "../../components/companyStructure";
import CertificateFlow from "../../components/certificateFlow";
import CertificateCharge from "../../components/certificateCharge";

const CertificateNotice = () => {
    const baseItem = [
        {
            title: <div>首页</div>,
        },
        {
            title: "申请认证",
        },
    ];

    const locaton = useLocation();
    const navigate = useNavigate();
    let subPath = locaton?.state?.subPath;

    switch (subPath) {
        case "c2":
            baseItem.push({
                title: "认证流程",
            });
            break;
        case "c3":
            baseItem.push({
                title: "认证收费",
            });
            break;
        default:
            // 如果需要处理其他情况，可以加上 default 分支
            break;
    }


    return (
        <div className={style.pageContainer}>
            <Breadcrumb
                items={baseItem}
            />

            <div className={style.content}>
                <div className={style.leftNavBar}>
                    <CertificateNavModule/>
                </div>

                <div className={style.rightMainContainer}>
                    <div>
                        <div className={style.pageTitle}>申请认证</div>
                        <Divider style={{padding: '0 30px', borderColor: '#043554'}}>APPLY FOR CERTIFICATION</Divider>
                    </div>

                    <div className={style.articleContainer}>
                        {subPath === "c2" ? (<CertificateFlow/>)
                            : subPath === "c3" ? (<CertificateCharge/>)
                                : (<div/>)}
                    </div>
                </div>
            </div>

        </div>

    );
};

export default CertificateNotice;